import React from 'react';

import { connect } from 'react-redux';
import { TrashSolid } from '@components/drive/driveIcons';
import {
  RoleLabel as RoleLabelWrapper,
  LeftRoleLabel,
  JobTitle,
  RightRoleLabel,
  CheckMark,
  DeleteRole,
  AddRole,
  CollapseRole,
  RoleLabelContainer,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/roleDetails';
import {
  SquareCheckMarkColored,
  Square,
  Chevron,
  PlusIcon,
} from '../../../../../../editJournal/toolset/assets/icons';
import componentSection from '../../../../LeftPane/componentSection';
import titleToSectionKey from '../../../../../../../../../store/helpers/titleToSectionKeyDict';

const RoleLabel = (props) => {
  const {
    currentRole,
    placeHolder,
    stopDrag,
    handleExport: exportHandler,
    handleDelete: deleteHandler,
    insertRole: insertHandler,
    editor,
    isCollapseChildren,
  } = props;

  const handleExport = (e) => exportHandler(e);
  const handleDelete = (e) => deleteHandler(e);
  const insertRole = (e) => insertHandler(e);

  // Get the path to use in data-testid
  const nodeKey = currentRole?.key;
  const path = editor?.value?.document?.getPath(nodeKey)?.toJS();
  const pathSuffix = path ? `-${path.join('-')}` : '';

  /**
   * Sync role label and job title
   */
  const { data } = currentRole;
  const toExport = data.get('toExport');

  const { nodes } = currentRole;
  const jobTitleNode = nodes.toArray()[0];
  const { text } = jobTitleNode;
  let jobTitle = text || placeHolder;
  if (jobTitle.length > 25) {
    jobTitle = `${jobTitle.slice(0, 25)}...`;
  }

  const sectionTitle = componentSection[currentRole.type];
  const sectionKey = titleToSectionKey[sectionTitle];

  const {
    [sectionKey]: { document },
  } = props;

  let rolesCount = 0;

  const organization = document && document.getParent(currentRole.key);

  rolesCount = organization && organization.nodes.size - 1;

  const collapseHandler = () => {
    const { key: roleKey, data: roleData } = currentRole;

    const roleDataJSON = roleData.toJSON();

    editor
      .setNodeByKey(roleKey, {
        data: {
          ...roleDataJSON,
          isCollapseChildren: !isCollapseChildren,
        },
      })
      .blur();
  };

  return (
    <RoleLabelContainer>
      <RoleLabelWrapper
        spellCheck={false}
        contentEditable={false}
        onClick={() => {
          editor.blur();
        }}
      >
        <LeftRoleLabel data-testid={`${currentRole.type}_label${pathSuffix}`}>
          <JobTitle>{jobTitle}</JobTitle>
        </LeftRoleLabel>
        <RightRoleLabel>
          <AddRole
            onMouseDown={(e) => e.preventDefault() && stopDrag}
            onClick={(e) => {
              e.stopPropagation();
              insertRole(e);
            }}
            data-testid={`${currentRole.type}_add${pathSuffix}`}
          >
            <PlusIcon color="white" width="16px" height="16px" />
          </AddRole>
          <DeleteRole
            onMouseDown={(e) => e.preventDefault() && stopDrag}
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(e);
            }}
            data-testid={`${currentRole.type}_delete${pathSuffix}`}
            disabled={rolesCount <= 1}
          >
            <TrashSolid width="16px" height="16px" />
          </DeleteRole>
          <CollapseRole
            onMouseDown={(e) => e.preventDefault() && stopDrag}
            onClick={(e) => {
              e.stopPropagation();
              collapseHandler();
            }}
            data-testid={`${currentRole.type}_collapse${pathSuffix}`}
            rolesCount={rolesCount}
            isCollapseChildren={isCollapseChildren}
          >
            <Chevron width="16px" height="16px" fill="#ffffff" />
          </CollapseRole>
        </RightRoleLabel>
      </RoleLabelWrapper>
      <CheckMark
        onMouseDown={(e) => e.preventDefault() && stopDrag}
        onClick={handleExport}
      >
        {
          {
            true: (
              <SquareCheckMarkColored
                width="16px"
                height="16px"
                dataTestId={`${currentRole.type}_check${pathSuffix}`}
              />
            ),
            false: (
              <Square
                width="16px"
                height="16px"
                dataTestId={`${currentRole.type}_uncheck${pathSuffix}`}
              />
            ),
          }[toExport]
        }
      </CheckMark>
    </RoleLabelContainer>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    currentRole: { type },
  } = ownProps;
  const sectionTitle = componentSection[type];
  const sectionKey = titleToSectionKey[sectionTitle];

  return {
    [sectionKey]: state.editResumeFormReducer[sectionKey], // re-renders organization details when there is an update in rolesCount properties
  };
};

export default connect(mapStateToProps)(RoleLabel);
